<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="ipqcChecks/dailyList"
        @addOrEdit="fillHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button type="primary" :loading="generateLoading" @click="generateHandle">
          生成今日稽核单
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="稽核日期">
            <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="dateChange"/>
          </el-form-item>
          <el-form-item label="来源模板">
            <el-input v-model.trim="filter.templateName" placeholder="请输入来源模板" clearable/>
          </el-form-item>
          <el-form-item label="线别">
            <el-input v-model.trim="filter.lineName" placeholder="请输入线别" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <ipqc-daily-edit ref="ipqcDailyEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import IpqcDailyEdit from "@/views/inspection/ipqcCheck/IpqcDailyEdit";

  export default {
    name: "IpqcDailyList",
    components: { IpqcDailyEdit, viewTable },
    data() {
      return {
        limits: {
          addAuth: false,
          editAuth: this.$auth(0),
          delAuth: this.$auth(0),
        },
        generateLoading: false,
        dateRange: [],
        filter: {
          beginDate: "",
          endDate: "",
          templateName: "",
          lineName: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                    fontWeight: "bold",
                  },
                  on: {
                    click: () => {
                      this.$refs.ipqcDailyEdit.open(params.row, true);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "sourceTemplateName",
            align: "center",
            minWidth: 240,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.ipqcDailyEdit.open(params.row, true);
                    },
                  },
                },
                params.row.sourceTemplateName || params.row.templateName,
              );
            },
          },
          {
            tooltip: true,
            key: "lineName",
            align: "center",
            width: 140,
          },
          {
            tooltip: true,
            key: "ipqcName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "auditor",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "statusName",
            align: "center",
            width: 100,
          },
          {
            key: "action",
            align: "center",
            width: 160,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      fillHandle(row) {
        if (row) {
          this.$refs.ipqcDailyEdit.open(row, false);
        }
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.postJson("basic", "ipqcChecks/daily/delete", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      generateHandle() {
        this.generateLoading = true;
        this.$http.post("basic", "ipqcChecks/generateDaily", {}, {}).then((resp) => {
          this.generateLoading = false;
          if (resp.success) {
            this.$message.success(`已生成 ${resp.data} 张稽核单`);
            this.loadData(1);
          }
        }).catch(() => {
          this.generateLoading = false;
        });
      },
      dateChange(date) {
        if (date !== null) {
          this.filter.beginDate = date[0];
          this.filter.endDate = date[1];
        } else {
          this.filter.beginDate = "";
          this.filter.endDate = "";
        }
      },
      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
